if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.defaultSubmitLabel =
          (this.submitButtonText && this.submitButtonText.textContent.trim()) ||
          this.dataset.submitLabel ||
          (window.variantStrings && window.variantStrings.addToCart) ||
          'Add to cart';

        if (!this.__ciwVariantResetBound) {
          this.__ciwVariantResetBound = true;
          document.addEventListener('variant:changed', () => {
            if (this.isConnected) this.resetSubmitButtonLabel();
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) quickAddModal.hide(true);
            this.showAddedToCartState();

            const cartUrl =
              (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js';

            return fetch(cartUrl, {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' },
            })
              .then((cartRes) => (cartRes.ok ? cartRes.json() : null))
              .then((cartData) => {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: cartData || response,
                });

                if (
                  window.CIW_CART_DRAWER &&
                  typeof window.CIW_CART_DRAWER.refreshAndOpen === 'function' &&
                  window.CIW_CART_DRAWER.isDesktop()
                ) {
                  return window.CIW_CART_DRAWER.refreshAndOpen();
                }
              });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      showAddedToCartState() {
        if (!this.submitButton) return;
        if (this.submitButtonText) {
          this.submitButtonText.textContent = 'Added to Cart!';
        }
        this.submitButton.classList.add('ciw-added-to-cart');
      }

      resetSubmitButtonLabel() {
        if (!this.submitButton || this.submitButton.classList.contains('loading')) return;
        if (this.submitButtonText) {
          this.submitButtonText.textContent = this.defaultSubmitLabel;
        }
        this.submitButton.classList.remove('ciw-added-to-cart');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          if (this.submitButtonText) {
            this.submitButtonText.textContent =
              text || this.dataset.submitLabel || window.variantStrings.addToCart;
          }
          this.defaultSubmitLabel = this.submitButtonText
            ? this.submitButtonText.textContent.trim()
            : this.defaultSubmitLabel;
        }

        if (this.variantIdInput) {
          this.variantIdInput.disabled = disable;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
